import { render, staticRenderFns } from "./interval.vue?vue&type=template&id=5080433b&scoped=true"
import script from "./interval.vue?vue&type=script&lang=js"
export * from "./interval.vue?vue&type=script&lang=js"
import style0 from "./interval.vue?vue&type=style&index=0&id=5080433b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080433b",
  null
  
)

export default component.exports